// extracted by mini-css-extract-plugin
export default {"primary":"MainButton_primary__YrvSH","secondary":"MainButton_secondary__NJUxr"};